import { UUID } from '@macs-frontend/core/utils/uuid';

export interface Distance {
  uuid: UUID;
  // float
  fromLat: number;
  // float
  fromLng: number;
  // float
  toLat: number;
  // float
  toLng: number;
  // in metres
  distance: number;
}
